export function getStateClass(value: string | null | undefined): string | null {
  switch ((value ?? '').toUpperCase()) {
    case 'LOW':
      return 'state-low';
    case 'MEDIUM':
      return 'state-medium';
    case 'HIGH':
      return 'state-high';
    case 'EXPERT':
      return 'state-expert';
    default:
      return null;
  }
}

export function getEngagementClass(
  value: string | null | undefined
): string | null {
  switch ((value ?? '').toUpperCase()) {
    case 'BACKUP':
      return 'engagement-backup';
    case 'LOW':
      return 'engagement-low';
    case 'MEDIUM':
      return 'engagement-medium';
    case 'AVERAGE':
      return 'engagement-average';
    case 'HIGH':
      return 'engagement-high';
    case 'MAX':
      return 'engagement-max';
    default:
      return null;
  }
}
